export const Colors = {
    black: '#000000',
    white: '#ffffff',
    lightGreen: '#A9D18E',
    lightRed: '#FF5353',
    navbarBackground: '#110d26',
    navbarBottomBackground: '#ffffff',
    blue: '#3e74d3',
}
